export const personalLifeData = {
  highlights: [
    {
      title: 'Family & Relationships',
      description: 'Family is the cornerstone of my life. I cherish quality time with loved ones, creating lasting memories through shared experiences, travel adventures, and celebrating life\'s precious moments together. The support and love of family provide the foundation for all my achievements.',
      image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/1953bab5d81958b0cb039d0c64ffdc18.jpeg'
    },
    {
      title: 'Community Engagement',
      description: 'Giving back to the community is a core value. I actively participate in mentorship programs, volunteer initiatives, and charitable causes that make a meaningful difference. Contributing to the growth and success of others brings immense fulfillment and purpose.',
      image: 'https://public.readdy.ai/ai/img_res/c85b7a79a954a54cd7b600e7ac31f4f5.jpg'
    }
  ],
  interests: [
    {
      name: 'Time with Family',
      description: 'Cherishing moments with loved ones',
      icon: 'ri-heart-line'
    },
    {
      name: 'Guitar',
      description: 'Playing and creating music',
      icon: 'ri-music-line'
    },
    {
      name: 'Gym',
      description: 'Fitness and strength training',
      icon: 'ri-run-line'
    },
    {
      name: 'Mentoring',
      description: 'Guiding the next generation',
      icon: 'ri-team-line'
    },
    {
      name: 'Travel',
      description: 'Exploring new destinations',
      icon: 'ri-plane-line'
    },
    {
      name: 'Chess',
      description: 'Strategic thinking and competition',
      icon: 'ri-sword-line'
    },
    {
      name: 'Tennis',
      description: 'Sports and physical activity',
      icon: 'ri-basketball-line'
    }
  ]
};
